import { __assign } from 'tslib';
import * as React from 'react';
import { DefaultImage } from './DefaultImage.esm.js';

var ContentfulImageContext = React.createContext(DefaultImage);
var ContentfulImage = function (props) {
    var Image = React.useContext(ContentfulImageContext);
    var asset = props.asset;
    if (!asset) {
        return null;
    }
    return React.createElement(Image, __assign({ "data-testid": "image" }, props));
};

export { ContentfulImage, ContentfulImageContext };
//# sourceMappingURL=ContentfulImage.esm.js.map
